export default {
  BR: 'Brasil',
  ES: 'Espanha',
  JP:'Japão',
  PT: 'Portugal',
  US:'Estados Unidos'
}